import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import momentTimezone from 'moment-timezone';
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

export default defineComponent(UserTimezone);

function UserTimezone() {
    this.after('initialize', function() {
        const timezone = this.$node.attr('data-designer-timezone');
        this.displayLocalTime(timezone);

        $(document).on('uiNeedsTimeUpdate', () => {
            this.displayLocalTime(timezone);
        });
    });

    this.displayLocalTime = function(timezone) {
        if (momentTimezone.tz.zone(timezone)) {
            var current = momentTimezone();
            var designersTimeInfo = this.$node.data('designers-time');
            const localTime = current.tz(timezone).format('LT');

            designersTimeInfo = designersTimeInfo.replace('%time%', localTime);
            this.$node.text(designersTimeInfo);
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/flight/ui/user-local-time.js